import React, { PropTypes } from 'react';
import { Field, reduxForm, FieldArray, formValueSelector, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import alert from 'alertify.js';
import { connect } from 'react-redux';
import axios from './../../../constants/axios';

import SelectAsync from './../../FormTemplate/SelectAsync';
import Select from './../../FormTemplate/Select';
import TextareaControl from './../../FormTemplate/TextareaControl';

import RenderLists from './Helper/RenderLists';

class NewPurchaseReturnForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         vendorAddresses: []
      };
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.contact_id && (typeof nextProps.contact_id === 'number') && nextProps.contact_id !== this.props.contact_id) {
         axios.get(`contacts/${nextProps.contact_id}/getAddresses`)
            .then((res) => {
               let n = res.data.map((add) => {
                  return {
                     value: add.id,
                     label: `${add.address} | ${add.contact_address_type_name}`
                  };
               });
               this.setState({
                  vendorAddresses: n
               });
            });
      }
      if (nextProps.items && nextProps.items.length > 0) {
         nextProps.items.forEach((item) => {
            if (item.price && item.unit) {
               item.total = item.price * item.unit;
            } else {
               item.total = '';
            }
         });
      }
   }

   submit = (values) => {
      const dataToSend = {
         contact_id: values.contact_id,
         contact_address_id: values.contact_address_id,
         items: values.items
      };
      if (values.memo) {
         dataToSend.memo = values.memo;
      }
      return axios.post('/purchaseReturns', dataToSend)
         .then((res) => {
            if (res.status === 201) {
               alert.success('invoice created.');
               this.context.router.push('/purchaseReturn');
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };

   render() {
      const { handleSubmit, items } = this.props;
      const total = items ? items.reduce((pre, item) => pre + (item.unit * item.price), 0) : 0;
      const { vendorAddresses } = this.state;
      return (
         <form noValidate autoComplete="off" onSubmit={handleSubmit(this.submit)} >
            <div className="row" >
               <div className="col-md-6" >
                  <Field name="contact_id" minimumInput={2} component={SelectAsync} link="contacts/vendors/searchByName"
                         label="Vendor Name" />
               </div>
               <div className="col-md-6" >
                  <Field name="contact_address_id" allowEmpty={true} component={Select} options={vendorAddresses}
                         label="Vendor Address" />
               </div>
            </div>
            <FieldArray items={items} name="items" component={RenderLists} />

            <hr />
            <p className="pull-right" >Total: {total}</p>
            <hr />

            <Field name="memo" label="Memo" component={TextareaControl} />
            <Button type="submit" bsStyle="success" block >Save</Button>
         </form>
      );
   }
}

NewPurchaseReturnForm.propTypes = {
   handleSubmit: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   contact_id: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number
   ])
};

NewPurchaseReturnForm.contextTypes = {
   router: PropTypes.object
};

NewPurchaseReturnForm = reduxForm({ // eslint-disable-line
   form: 'inventoryPurchaseReturnForm'
})(NewPurchaseReturnForm);

const selector = formValueSelector('inventoryPurchaseReturnForm');

NewPurchaseReturnForm = connect(state => { // eslint-disable-line
   const items = selector(state, 'items');
   const contact_id = selector(state, 'contact_id');
   return {
      items,
      contact_id
   };
})(NewPurchaseReturnForm);


export default NewPurchaseReturnForm;






/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/PurchaseReturn/NewPurchaseReturnForm.js
 **/